export default {
  time_options: {
    asap: {
      title: 'Imediato',
      description: 'Pronto em {{time}} min',
    },
    scheduled: {
      title: 'Agendar para mais tarde',
    },
  },
};
